import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockID, setAttributes } ) {
	const unique = `.block-${ blockID }`;
	const {
		textAlignment,
		maxContentWidth,
		minHeight,
		margin,
		padding,
		border,
		borderRadius,
		containerBackground,
		containerShadow,
		typography,
		buttonTextColor,
		buttonHoverTextColor,
		buttonHoverBackgroundColor,
		buttonHoverBorder,
		buttonHoverOpacity,
		iconSpacing,
		iconPosition,
	} = attributes;

	const buttonHoverOpacityValue = buttonHoverOpacity?.desktop?.val
		? parseFloat( buttonHoverOpacity.desktop.val ) / 100
		: undefined;

	const CssObj = {
		[ unique ]: [GenerateCss.css( 'text-align', textAlignment )],
		[ `${ unique } a` ]: [
			GenerateCss.css( 'display', 'inline-block' ),
			GenerateCss.lengthProp( 'max-width', maxContentWidth ),
			GenerateCss.lengthProp( 'min-height', minHeight ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
			GenerateCss.border( border ),
			GenerateCss.borderRadius( borderRadius ),
			GenerateCss.background( containerBackground ),
			GenerateCss.boxShadow( containerShadow ),
			GenerateCss.typography( typography ),
			GenerateCss.textColor( buttonTextColor ),
		],
		[ `${ unique } .alpha-icon` ]: [
			GenerateCss.lengthProp(
				iconPosition === 'left' ? 'margin-right' : 'margin-left',
				iconSpacing
			),
		],
		[ `${ unique } .alpha-icon svg` ]: [
			GenerateCss.css( 'fill', 'currentColor' ),
		],
		[ `${ unique } a:hover` ]: [
			GenerateCss.textColor( buttonHoverTextColor ),
			GenerateCss.background( buttonHoverBackgroundColor ),
			GenerateCss.border( buttonHoverBorder ),
			GenerateCss.css( 'opacity', String(buttonHoverOpacityValue) ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
